<template>
  <div
    class="menu-contact"
    :class="isDesktopMenu ? 'menu-contact__border-top' : ''"
  >
    <p class="menu-contact__header -upper font-btn">
      {{ $t('need help?') }}
    </p>
    <ul class="menu-contact__content pl-0 pt-4">
      <li v-if="showPhone" class="menu-contact__content--item">
        <a
          :href="'tel:' + $t('phone')"
          @click="webToCallEvent({ method: 'phone', linkUrl: $t('phone') })"
          class="mx-0 mb-4 pb-0 d-flex align-items-center menu-contact__content--link"
        >
          <contact-phone-icon class="flex-shrink-0" />
          <p class="menu-contact__content--link-text -upper ml-4 mb-0">
            <span v-text="$t('Call us at:')"></span>
            {{ $t('phone') }}
          </p>
        </a>
      </li>
      <li class="menu-contact__content--item d-flex align-items-center">
        <router-link
          :to="localizedUrl + '/contact'"
          class="mx-0 pb-0 d-flex align-items-center menu-contact__content--link"
        >
          <contact-mail-icon class="flex-shrink-0" />
          <span
            class="menu-contact__content--link-text -upper ml-4"
            v-text="$t('Contact us by') + ' Email'"
          >
          </span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import { webToCallEvent } from '../../utilities/trackEvent'
import ContactPhoneIcon from './ContactPhoneIcon.vue'
import ContactMailIcon from './ContactMailIcon.vue'

export default {
  name: 'MenuContactInfo',
  props: {
    isDesktopMenu: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ContactPhoneIcon,
    ContactMailIcon
  },
  computed: {
    localizedUrl() {
      return currentStoreView().url || ''
    },
    phoneNumber() {
      return currentStoreView().contactPhone
    },
    showPhone() {
      return (
        currentStoreView().is_e_com && !currentStoreView().is_global_e_store
      )
    }
  },
  methods: {
    webToCallEvent
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

.menu-contact {
  --_contact-color: var(--_zenith-header-text, var(--zenith-white));

  padding-block: 5rem 0;
  color: var(--_contact-color);

  @include bp(max md) {
    padding-block: 3rem;
  }

  &__border-top {
    border-top: 0.1rem solid
      var(--_zenith-color-transparent, var(--zenith-white-transparent));
  }

  .menu-contact__content {
    &--item::marker {
      font-size: 0;
    }

    &--link {
      --_underline-width: 0%;

      color: var(--_contact-color);

      &-text {
        font-weight: 300;
        font-size: 1.1rem;
        letter-spacing: 0;
        display: inline-block;
        position: relative;

        &:before {
          position: absolute;
          content: '';
          display: block;
          height: 0.1rem;
          width: var(--_underline-width);
          background-color: var(--_contact-color);
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          transition: all 0.2s ease-in-out;
        }
      }

      &:hover,
      &:focus {
        --_underline-width: 100%;
      }
    }
  }
}
</style>
